import React, {useState, useEffect} from 'react';
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import { Input, message,Statistic,Progress  } from 'antd';
import {balanceOf,signer, transfer} from '../../utils/ethers'

import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import {useNavigate} from "react-router-dom";
import { useTranslation } from 'react-i18next'
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';

import '../invite/index.less'
import './game.css'
import {getGameIndex} from "../../api";
import CountUp from "react-countup";
import { CSSTransition } from 'react-transition-group';
const { Countdown } = Statistic;
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        chain:state.chain
    }
}

const Game = (props) => {
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [show0,setShow0] = useState(false)
    const [show1,setShow1] = useState(false)
    const [show2,setShow2] = useState(false)
const navigate = useNavigate()

    const [feg_n,setFegN] = useState("")
    const [fegw_n,setFegwN] = useState("")
    const [usdt_n,setUsdtN] =useState("")

    const [fegBonus,setFegBonus] = useState("")
    const [fegwBonus,setFegwBonus] = useState("")
    const [usdtBonus,setUsdtBonus] =useState("")

    const [userFegJoinToday,setUserFegJoinToday] =useState("")
    const [userFegwJoinToday,setUserFegwJoinToday] =useState("")
    const [userUsdtJoinToday,setUserUsdtJoinToday] =useState("")

    const [userFegJoinAll,setUserFegJoinAll] =useState("")
    const [userFegwJoinAll,setUserFegwJoinAll] =useState("")
    const [userUsdtJoinAll,setUserUsdtJoinAll] =useState("")

    const [userFegWinToday,setUserFegWinToday] =useState("")
    const [userFegwWinToday,setUserFegwWinToday] =useState("")
    const [userUsdtWinToday,setUserUsdtWinToday] =useState("")

    const [userFegWinAll,setUserFegWinAll] =useState("")
    const [userFegwWinAll,setUserFegwWinAll] =useState("")
    const [userUsdtWinAll,setUserUsdtWinAll] =useState("")

    const [bossFegJoinToday,setBossFegJoinToday] =useState("")
    const [bossFegwJoinToday,setBossFegwJoinToday] =useState("")
    const [bossUsdtJoinToday,setBossUsdtJoinToday] =useState("")

    const [bossFegJoinAll,setBossFegJoinAll] =useState("")
    const [bossFegwJoinAll,setBossFegwJoinAll] =useState("")
    const [bossUsdtJoinAll,setBossUsdtJoinAll] =useState("")

    const [bossFegWinToday,setBossFegWinToday] =useState("")
    const [bossFegwWinToday,setBossFegwWinToday] =useState("")
    const [bossUsdtWinToday,setBossUsdtWinToday] =useState("")

    const [bossFegWinAll,setBossFegWinAll] =useState("")
    const [bossFegwWinAll,setBossFegwWinAll] =useState("")
    const [bossUsdtWinAll,setBossUsdtWinAll] =useState("")
    
    const [gameLevel,setGameLevel] =useState("")
    const [gameBig,setGameBig] =useState("")





  
    
    

  

    
 














    const _getGameIndex= () =>{
        if(props.address.length === 0 || props.isLogin === false){
            return false
        }
        getGameIndex().then(res=>{
            if(res.code === 0 ){

                
              
               setUsdtN(res.data.usdt_n)
               setFegN(res.data.feg_n)
               setFegwN(res.data.fegw_n)
                

               setUserFegJoinToday(res.data.userFegJoinToday)
               setUserFegJoinAll(res.data.userFegJoinAll)
               setUserFegwJoinToday(res.data.userFegwJoinToday)
               setUserFegwJoinAll(res.data.userFegwJoinAll)
               setUserUsdtJoinToday(res.data.uerUsdtJoinToday)
               setUserUsdtJoinAll(res.data.userUsdtJoinAll)

               setUserFegWinToday(res.data.userFegWinToday)
               setUserFegWinAll(res.data.userFegWinAll)
               setUserFegwWinToday(res.data.userFegwWinToday)
               setUserFegwWinAll(res.data.userFegwWinAll)
               setUserUsdtWinToday(res.data.userUsdtWinToday)
               setUserUsdtWinAll(res.data.userUsdtWinAll)

                setBossFegJoinToday(res.data.bossFegJoinToday)
               setBossFegJoinAll(res.data.bossFegJoinAll)
               setBossFegwJoinToday(res.data.bossFegwJoinToday)
               setBossFegwJoinAll(res.data.bossFegwJoinAll)
               setBossUsdtJoinToday(res.data.bossUsdtJoinToday)
               setBossUsdtJoinAll(res.data.bossUsdtJoinAll)

                setBossFegWinToday(res.data.bossFegWinToday)
               setBossFegWinAll(res.data.bossFegWinAll)
               setBossFegwWinToday(res.data.bossFegwWinToday)
               setBossFegwWinAll(res.data.bossFegwWinAll)
               setBossUsdtWinToday(res.data.bossUsdtWinToday)
               setBossUsdtWinAll(res.data.bossUsdtWinAll)

               setFegwBonus(res.data.fegw_bonus)
               setFegBonus(res.data.feg_bonus)
               setUsdtBonus(res.data.usdt_bonus)

               setGameLevel(res.data.game_level)
               setGameBig(res.data.game_big)
     
                // if(res.data.minted >0){
                //     let _par =  Math.round(res.data.minted / 5000000 *10000)/100
                //     if(_par >100){
                //         _par = 100
                //     }
                //     setPar(_par)
                // }
                

                    

                    //console.log(_par)
                    

            }else{
                message.error(res.msg)
            }
        },error =>{
            message.error(error)
        })

    }

 



  


 

    const goGame = (e) =>{
        if(props.address.toLowerCase() == "0x585e926c2a4b746b56fc99dd543a1d0a5b4e94ff"){

        }else{
            message.error(t('g.暂未开始'))
            return
        }
        
        if(e==0){
            if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
            navigate("/game160",{
                state:{
                    address:props.address
                }
            })
        }else if(e==2){
            if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
             navigate("/game1",{
                state:{
                    address:props.address
                }
            })
       
            
        }else{
             message.error(t('g.暂未开始'))
            return
        }
       

        
        
    }

    useEffect(() => {
             window.scrollTo(0, 0)
            _getGameIndex()

    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    return (
        <>
    
            <Head/>
            
            <div  className="  w-full lg:w-1/3   pt-20 text-white flex flex-col relative z-10" >

                {/* <div className='mt-10 w-full flex felx-row justify-center'>
                            <img  alt='rr' className='' src={require('../../assets/img/logo.png')} style={{"width":"154px"}}></img>
                        </div> */}
                        <div className="w-[145px]  mt-8 ml-4   py-1 flex felx-row justify-center items-center  bg-[#EFB612] rounded-3xl">
                            <img  alt='rr' className='mr-1' src={require('../../assets/img/c4.png')} style={{"width":"20px"}}></img>
                            <span className=' text-sm text-black'>TRON Chain</span>
                        </div>
                        <div className="w-full px-4 mt-[30px] mb-[17px]  flex felx-row justify-start items-center">
                            
                            <span className=' text-3xl text-white'>{t('game.元宝哈希预言')}</span>
                        </div>
                        <div className="w-full px-4 mt-[10px] mb-[15px]  flex felx-row justify-start items-center">
                            
                            <p className=' text-sm text-[#999999] fontM'>{t('game.核心玩法')}</p>
                        </div>
                {/* <div className=" mt-1 h-[100px] mx-4 flex flex-row justify-center items-center bg-[#EFB612] rounded-3xl">
                    <div className='w-1/3 flex flex-col items-center justify-center'>
                            <span className='text-sm text-white'><CountUp start={0} end={feg_n} duration="1" decimals={2} /></span>
                            <span className='text-xs mt-2 text-gray-300'>FEG</span>
                    </div>
                    <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}>
                            
                    </div>
                     <div className='w-1/3 flex flex-col items-center justify-center'>
                            <span className='text-sm text-white'><CountUp start={0} end={fegw_n} duration="1" decimals={2} /></span>
                            <span className='text-xs mt-2 text-gray-300'>FEGW </span>
                    </div>
                    <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}>
                            
                    </div>
                    <div className='w-1/3 flex flex-col items-center justify-center'>
                            <span className='text-sm text-white'><CountUp start={0} end={usdt_n} duration="1" decimals={2} /></span>
                            <span className='text-xs mt-2 text-gray-300'>USDT</span>
                    </div>
                    
                </div> */}

                <div className=' w-full h-6 mx-auto mt-[40px]  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('game.游戏排行')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div>

                    <div className='mx-4 mt-8  flex flex-row justify-between items-start'>
                    <div onClick={()=>goGame(0)} className='  relative flex flex-row justify-center items-center'>
                        <span className=' text-base text-white absolute '>{t('game.量子奇偶')}</span>
                        <img alt='rr' className=' w-40 h-60 rounded-xl' src={require('../../assets/bg/game/g1.jpg')}></img>
                    </div>

                    <div onClick={()=>goGame(2)} className='  relative flex flex-row justify-center items-center'>
                        <span className=' text-base text-white absolute'>{t('game.30秒奇偶')}</span>
                        <img alt='rr' className=' w-40 h-60 rounded-xl' src={require('../../assets/bg/game/g3.jpg')}></img>
                    </div>
                   
                    
                </div>

                {/* 0 */}

                {
                    !show0?(
                        <div className='mx-4 h-14 mt-8 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-row justify-center items-center relative'>
                            <div className=' w-full flex flex-row justify-end items-center absolute right-0'>
                                <img onClick={()=>setShow0(true)} alt='rr' className='mr-6' src={require('../../assets/bg/game/b.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <img  alt='rr' className='mr-1' src={require('../../assets/bg/game/icon0.png')} style={{"height":"20px"}}></img>
                            <span className=" text-base text-white">{t('game.平台动态')}</span>

                        </div>
                    ):(
                        <div className='mx-4 h-[449px] mt-8 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-col  items-center'>
                            <div className=' w-full h-14 flex flex-row justify-center items-center relative'>
                                <span className=" text-base text-white">{t('game.平台动态')}</span>
                                <img onClick={()=>setShow0(false)} alt='rr' className='mr-6 absolute right-0' src={require('../../assets/bg/game/t.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <div className=' w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} FEG</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} FEG</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} FEG</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} FEG</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegwJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} FEGW</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegwJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} FEGW</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegwWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} FEGW</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossFegwWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} FEGW</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossUsdtJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} USDT</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossUsdtJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} USDT</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossUsdtWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} USDT</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={bossUsdtWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} USDT</span>
                                </div>
                            </div>

                        </div>
                    )
                }
                

                 

                {/*  */}
                {/* 1 */}

                {
                    !show1?(
                        <div className='mx-4 h-14 mt-8 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-row justify-center items-center relative'>
                            <div className=' w-full flex flex-row justify-end items-center absolute right-0'>
                                <img onClick={()=>setShow1(true)} alt='rr' className='mr-6' src={require('../../assets/bg/game/b.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <img  alt='rr' className='mr-1' src={require('../../assets/bg/game/icon2.png')} style={{"height":"25px"}}></img>
                            <span className=" text-base text-white">{t('game.用户动态')}</span>

                        </div>
                    ):(
                        <div className='mx-4 h-[449px] mt-8 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-col  items-center'>
                            <div className=' w-full h-14 flex flex-row justify-center items-center relative'>
                                <span className=" text-base text-white">{t('game.用户动态')}</span>
                                <img onClick={()=>setShow1(false)} alt='rr' className='mr-6 absolute right-0' src={require('../../assets/bg/game/t.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <div className=' w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} FEG</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} FEG</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} FEG</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} FEG</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegwJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} FEGW</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegwJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} FEGW</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegwWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} FEGW</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userFegwWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} FEGW</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtJoinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.今日流量')} USDT</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtJoinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计流量')} USDT</span>
                                </div>
                            </div>
                            <div className=' mt-2 w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtWinToday} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.当日盈亏')} USDT</span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'><CountUp start={0} end={userUsdtWinAll} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-400'>{t('game.累计盈亏')} USDT</span>
                                </div>
                            </div>

                        </div>
                    )
                }
                

 

                {/*  */}
                 {/* 2 */}

                 {
                    !show2?(
                        <div className='mx-4 h-14 mt-8 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-row justify-center items-center relative'>
                            <div className=' w-full flex flex-row justify-end items-center absolute right-0'>
                                <img onClick={()=>setShow2(true)} alt='rr' className='mr-6' src={require('../../assets/bg/game/b.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <img  alt='rr' className='mr-1' src={require('../../assets/bg/game/ic1.png')} style={{"height":"25px"}}></img>
                            <span className=" text-base text-white">{t('game.社区动态')}</span>

                        </div>
                    ):(
                        <div className='mx-4 h-60 mt-8 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-col  items-center'>
                            <div className=' w-full h-14 flex flex-row justify-center items-center relative'>
                                <span className=" text-base text-white">{t('game.社区动态')}</span>
                                <img onClick={()=>setShow2(false)} alt='rr' className='mr-6 absolute right-0' src={require('../../assets/bg/game/t.png')} style={{"width":"16px","height":"16px"}}></img>
                            </div>
                            <div className=' w-full h-12 flex flex-row justify-center items-center'>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    <span className='text-sm text-white'>$<CountUp start={0} end={gameBig} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-300'>{t('game.团队贡献')} </span>
                                </div>
                                <div className='w-px mx-2 h-9' style={{"backgroundColor":"#EFEFEF05"}}></div>
                                <div className='w-1/2 flex flex-col items-center justify-center'>
                                    {/* <span className='text-sm text-white'><CountUp start={0} end={0} duration="1" decimals={2} /></span>
                                    <span className='text-xs mt-2 text-gray-300'>{t('game.累计流量')} MARS</span> */}
                                </div>
                            </div>
                           
                           

                        </div>
                    )
                 }
                

                 

                {/*  */}

                <div className='mx-4 h-16 mt-8 px-4 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-row justify-between items-center relative'>
                    <span className=" text-sm text-white">{t('game.我的级别')}:{gameLevel==0?t('game.普通船员'):gameLevel==1?t('game.星际探索者'):gameLevel==2?t('game.星际领主'):gameLevel==3?t('game.银河统帅'):t('game.宇宙元老')}</span>
                    <img alt='rr' className='mr-1' src={require('../../assets/bg/share/title.png')} style={{"width":"30px","height":"30px"}}></img>
                </div>

                <div className='mx-4 h-20 mt-8 px-4 bg-[#323233] border-[1px] border-[#727477] rounded-xl flex flex-row justify-start items-start relative'>
                    <div className=" h-20 text-sm text-gray-300 flex flex-row items-center">{t('game.游戏基金总额')}</div>
                    <div className='h-20 flex flex-col items-start justify-center ml-4'>
                        <span className=" text-xs text-white mb-1">FEG：<CountUp start={0} end={fegBonus} duration="1" decimals={2} /></span>
                     <span className=" text-xs text-white mb-1">FEGW：<CountUp start={0} end={fegwBonus} duration="1" decimals={2} /></span>
                      <span className=" text-xs text-white mb-1">USDT：<CountUp start={0} end={usdtBonus} duration="1" decimals={2} /></span>
                    </div>
                    
                    <img alt='rr' className=' absolute right-0 top-1' src={require('../../assets/bg/game/image.png')} style={{"width":"65px","height":"65px"}}></img>
                </div>

                 {/* <div className=' w-full h-6 mx-auto mt-[40px]  pt-1 flex flex-row justify-center items-center  '>
                    <img alt='rr' className=' mr-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                    <span className=' text-sm text-text-act'>{t('game.游戏排行')}</span>
                    <img alt='rr' className=' ml-2' src={require('../../assets/bg/share/title.png')} style={{"width":"42px"}}></img>
                </div> */}

                {/* <div className='mx-4 mt-8  flex flex-row justify-between items-start'>
                    <div onClick={()=>goGame(0)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.量子奇偶')}</span>
                        <img alt='rr' className=' w-40 h-60' src={require('../../assets/bg/game/g1.png')}></img>
                    </div>
                   <div onClick={()=>goGame(1)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.尾数天地')}</span>
                        <img alt='rr' className=' w-40 h-60 ' src={require('../../assets/bg/game/g2.png')}></img>
                    </div>
                    
                </div> */}
                {/* <div className='mx-4 mt-8  flex flex-row justify-between items-start'>
                    <div onClick={()=>goGame(1)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.尾数天地')}</span>
                        <img alt='rr' className=' w-40 h-60 ' src={require('../../assets/bg/game/g2.png')}></img>
                    </div>
                   <div onClick={()=>goGame(3)} className='  relative flex flex-row justify-center items-end'>
                        <span className=' text-base text-white absolute bottom-7'>{t('game.30秒天地')}</span>
                        <img alt='rr' className=' w-40 h-60 ' src={require('../../assets/bg/game/g4.png')}></img>
                    </div>
                    
                </div> */}

                                                        

                {/*  */}

               <div className=' w-full mt-[60px] font10 text-gray-300 flex flex-row justify-center items-center'>
                     CopyRight@ FEG Golden Federal Reserve 2025
                </div>


            
            </div>
            

                <div className=' w-full h-[684px] fixed bottom-0 gameTbg11 z-0'>

                </div>
           {/* <Foot/> */}
        </>
    );
}

export default connect(mapStateToProps)(Game);
